<div [ngClass]="{ 'overlay': isLoading }">
  @if (isLoading) {
    <div class="w-full h-full flex justify-center items-center">
      <mat-spinner></mat-spinner>
    </div>
  }

  @if (!isLoading && data.length === 0) {
    <app-notification-block
      [header]="'No static data available for the building'"
      [statusClass]="StatusClass.WARNING">
      Data is not available for the selected building. Please check the selected building and try again.
    </app-notification-block>
  }

  <div class="overflow-x-auto">
    <mat-table class="overflow-auto mat-elevation-z8 w-[93vw]"
               [dataSource]="data"
               [ngClass]="{'invisible': isLoading || data.length === 0}">

      <ng-container matColumnDef="nodeId">
        <mat-header-cell *matHeaderCellDef>Node ID</mat-header-cell>
        <mat-cell *matCellDef="let row" [attr.data-cy]="'static-node-id-cell-' + row.nodeId">
          <a [attr.data-cy]="'adm-node-link-' + row.nodeId" class="text-blue-600 cursor-pointer" (click)="navigateToUrl(row.sensorNodeLink)">
            {{ row.nodeId }}
          </a>
        </mat-cell>
      </ng-container>

<ng-container matColumnDef="gtin">
        <mat-header-cell *matHeaderCellDef>GTIN</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.gtin) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="identificationNumber">
        <mat-header-cell *matHeaderCellDef>Driver Identification Number</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.identificationNumber) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="responseCode">
        <mat-header-cell *matHeaderCellDef>Response Code</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.responseCode) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="firmwareVersion">
        <mat-header-cell *matHeaderCellDef>Firmware Version</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.firmwareVersion) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="hardwareVersion">
        <mat-header-cell *matHeaderCellDef>Hardware Version</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.hardwareVersion) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="additionalControlGearInformation">
        <mat-header-cell *matHeaderCellDef>Additional CG Info</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.additionalControlGearInformation) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="luminaireYearOfManufacture">
        <mat-header-cell *matHeaderCellDef>Year of Manufacture</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.luminaireYearOfManufacture) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="luminaireWeekOfManufacture">
        <mat-header-cell *matHeaderCellDef>Week of Manufacture</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.luminaireWeekOfManufacture) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nominalInputPower">
        <mat-header-cell *matHeaderCellDef>Nominal Input Power</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.nominalInputPower, 'W') }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="powerAtMinimumDimLevel">
        <mat-header-cell *matHeaderCellDef>Power at Min Dim Level</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.powerAtMinimumDimLevel, 'W') }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nominalMinimumACMainsVoltage">
        <mat-header-cell *matHeaderCellDef>Min AC Mains Voltage</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.nominalMinimumACMainsVoltage, 'V') }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nominalMaximumACMainsVoltage">
        <mat-header-cell *matHeaderCellDef>Max AC Mains Voltage</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.nominalMaximumACMainsVoltage, 'V') }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="nominalLightOutput">
        <mat-header-cell *matHeaderCellDef>Nominal Light Output</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.nominalLightOutput, 'lm') }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="cri">
        <mat-header-cell *matHeaderCellDef>CRI</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.cri) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="cct">
        <mat-header-cell *matHeaderCellDef>CCT</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.cct, 'K') }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="lightDistributionType">
        <mat-header-cell *matHeaderCellDef>Light Distribution Type</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.lightDistributionType) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="luminaireColor">
        <mat-header-cell *matHeaderCellDef>Luminaire Color</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.luminaireColor) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="luminaireIdentification">
        <mat-header-cell *matHeaderCellDef>Luminaire Identification</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.luminaireIdentification) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="version101VersionNumber">
        <mat-header-cell *matHeaderCellDef>Version 101</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.version101VersionNumber) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="version102VersionNumberOfAllIntegratedControlGear">
        <mat-header-cell *matHeaderCellDef>Version 102 (CG)</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.version102VersionNumberOfAllIntegratedControlGear) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="version103VersionNumberOfAllIntegratedControlDevices">
        <mat-header-cell *matHeaderCellDef>Version 103 (CD)</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.version103VersionNumberOfAllIntegratedControlDevices) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="numberOfLogicalControlDeviceUnitsInTheBusUnit">
        <mat-header-cell *matHeaderCellDef>Logical CD Units</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.numberOfLogicalControlDeviceUnitsInTheBusUnit) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="numberOfLogicalControlGearUnitsInTheBusUnit">
        <mat-header-cell *matHeaderCellDef>Logical CG Units</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.numberOfLogicalControlGearUnitsInTheBusUnit) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="indexNumberOfThisLogicalControlGearUnit">
        <mat-header-cell *matHeaderCellDef>CG Unit Index</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.indexNumberOfThisLogicalControlGearUnit) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="versionOfTheMemoryBank201">
        <mat-header-cell *matHeaderCellDef>Memory Bank 201</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.versionOfTheMemoryBank201) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="guaranteedSupplyCurrentOfIntegratedDaliBusPowerSupplyInMa">
        <mat-header-cell *matHeaderCellDef>Guaranteed DALI Supply (mA)</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.guaranteedSupplyCurrentOfIntegratedDaliBusPowerSupplyInMa) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="maximumSupplyCurrentOfIntegratedDaliBusPowerSupplyInMa">
        <mat-header-cell *matHeaderCellDef>Max DALI Supply (mA)</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.maximumSupplyCurrentOfIntegratedDaliBusPowerSupplyInMa) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="versionOfTheMemoryBank202">
        <mat-header-cell *matHeaderCellDef>Memory Bank 202</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.versionOfTheMemoryBank202) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="versionOfTheMemoryBank205">
        <mat-header-cell *matHeaderCellDef>Memory Bank 205</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.versionOfTheMemoryBank205) }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="versionOfTheMemoryBank206">
        <mat-header-cell *matHeaderCellDef>Memory Bank 206</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ display(row.versionOfTheMemoryBank206) }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="staticTableColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: staticTableColumns;"></mat-row>
    </mat-table>
  </div>
</div>
